import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';
import CombinedGroupItem from '../item/combinedGroupItem';

/**
 * Combine items command
 *
 * @class CombineItemsCommand
 * @extends AbstractCommand
 */
export default class CombineItemsCommand extends AbstractCommand {
    /**
     * @param {ItemCollection} itemCollection
     * @param {SelectionCollection} selection
     * @param {AbstarctItem[]} items
     */
    constructor(itemCollection, selection, items) {
        super();
        if (!Array.isArray(items) || items.length <= 1) {
            throw new Error('Only one item is selected.');
        }

        const parentItem = items[0].getParentItem();

        this.itemCollection = itemCollection;
        this.selection = selection;
        this.items = items;

        this.groupItem = new CombinedGroupItem({}, {}, parentItem);
    }

    /**
     * Execute command
     */
    execute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.items);
        this.groupItem.addItems(this.items);
        this.itemCollection.add(this.groupItem);

        this.selection.selectItem(this.groupItem, true);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.groupItem);
        this.itemCollection.add(this.items);

        this.selection.selectItems(this.items, true);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return 'Combine items';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.CombineItemsCommand = CombineItemsCommand;
